import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function Accordion({ items, testidBase = "faq" }) {
  const [open, setOpen] = useState(-1);

  return (
    <div className="divide-y divide-white/5 border-y border-white/5" data-testid={`${testidBase}-accordion`}>
      {items.map((item, i) => (
        <div key={i} data-testid={`${testidBase}-item-${i}`}>
          <button
            onClick={() => setOpen(open === i ? -1 : i)}
            data-testid={`${testidBase}-toggle-${i}`}
            aria-expanded={open === i}
            className="w-full flex items-center justify-between gap-6 py-6 text-left group"
          >
            <span className={`text-lg sm:text-xl font-medium transition-colors duration-200 ${open === i ? "text-neon" : "text-white group-hover:text-neon"}`}>
              {item.q}
            </span>
            <motion.span
              animate={{ rotate: open === i ? 45 : 0 }}
              transition={{ duration: 0.25 }}
              className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-colors ${open === i ? "border-neon text-neon" : "border-white/15 text-mist"}`}
            >
              <Plus size={16} />
            </motion.span>
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="overflow-hidden"
              >
                <p className="pb-7 pr-10 text-mist leading-relaxed max-w-3xl" data-testid={`${testidBase}-answer-${i}`}>
                  {item.a}
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
